import { render, staticRenderFns } from "./football-time-line.vue?vue&type=template&id=184ae011&scoped=true&"
import script from "./football-time-line.vue?vue&type=script&lang=js&"
export * from "./football-time-line.vue?vue&type=script&lang=js&"
import style0 from "./football-time-line.vue?vue&type=style&index=0&id=184ae011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184ae011",
  null
  
)

export default component.exports